import styled from 'styled-components';

export const HomeContainer = styled.div`
  width: 100vw;
`;
